module.exports = __webpack_public_path__ + "static/media/ng03.589ecbad.webp";